import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  TaxonomiesResponse,
  ResponseTaxonomy,
  ResponseTaxonomiesResponse,
  SituationTaxonomy,
  SituationTaxonomiesResponse,
} from '../../shared/models/taxonomy.models';
import { PageParams } from '../../shared/models/pagination.models';

@Injectable({ providedIn: 'root' })
export class TaxonomyService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  // ── Taxonomies ────────────────────────────────────────────────────────────

  getTaxonomies(params: PageParams = { pageSize: 10, pageIndex: 0, filter: '' }) {
    const httpParams = new HttpParams()
      .set('pageSize', params.pageSize ?? 10)
      .set('pageIndex', params.pageIndex ?? 0)
      .set('filter', params.filter ?? '');
    return this.http.get<TaxonomiesResponse>(`${this.apiUrl}/api/taxonomies`, {
      params: httpParams,
    });
  }

  // ── Situation Taxonomies ──────────────────────────────────────────────────

  getSituationTaxonomies() {
    return this.http.get<SituationTaxonomiesResponse>(`${this.apiUrl}/api/situation-taxonomies`);
  }

  getSituationTaxonomyById(id: string) {
    return this.http.get<SituationTaxonomy>(`${this.apiUrl}/api/situation-taxonomies/${id}`);
  }

  createSituationTaxonomy(payload: { name: string; isMultiItem: boolean }) {
    return this.http.post<SituationTaxonomy>(`${this.apiUrl}/api/situation-taxonomies`, payload);
  }

  updateSituationTaxonomy(payload: SituationTaxonomy) {
    return this.http.put<SituationTaxonomy>(`${this.apiUrl}/api/situation-taxonomies`, payload);
  }

  deleteSituationTaxonomy(id: string) {
    return this.http.delete<void>(`${this.apiUrl}/api/situation-taxonomies/${id}`);
  }

  // ── Response Taxonomies ───────────────────────────────────────────────────

  getResponseTaxonomies() {
    return this.http.get<ResponseTaxonomiesResponse>(`${this.apiUrl}/api/response-taxonomies`);
  }

  getResponseTaxonomyById(id: string) {
    return this.http.get<ResponseTaxonomy>(`${this.apiUrl}/api/response-taxonomies/${id}`);
  }

  createResponseTaxonomy(payload: { taxonomyName: string; isMultiItem: boolean }) {
    return this.http.post<ResponseTaxonomy>(`${this.apiUrl}/api/response-taxonomies`, payload);
  }

  updateResponseTaxonomy(payload: ResponseTaxonomy) {
    return this.http.put<ResponseTaxonomy>(`${this.apiUrl}/api/response-taxonomies`, payload);
  }

  deleteResponseTaxonomy(id: string) {
    return this.http.delete<void>(`${this.apiUrl}/api/response-taxonomies/${id}`);
  }
}
